import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
var i18n = createInstance({
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "Minmatar Republic",
        "warzone.faction.amarr": "Amarr Empire",
        "warzone.faction.gallente": "Gallente Federation",
        "warzone.faction.caldari": "Caldari State",
        "warzone.faction.guristas": "Guristas Pirates",
        "warzone.faction.angel": "Angel Cartel",
        "warzone.faction-short.minmatar": "Minmatar",
        "warzone.faction-short.amarr": "Amarr",
        "warzone.faction-short.gallente": "Gallente",
        "warzone.faction-short.caldari": "Caldari",
        "warzone.corporation.gallente": "Federal Defense Union",
        "warzone.corporation.caldari": "State Protectorate",
        "warzone.corporation.amarr": "24th Imperial Crusade",
        "warzone.corporation.minmatar": "Tribal Liberation Force",
        "warzone.corporation.angel": "Angel Cartel",
        "warzone.corporation.guristas": "Guristas Pirates",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>Uncontested</b>",
        "warzone.status.stable": "<b>Stable</b>",
        "warzone.status.contested": "<b>Contested</b>",
        "warzone.status.vulnerable": '<font color="red"><b>Vulnerable</b></font>',
        "warzone.tooltip.progress": '<font color="white"><b>{{count}}</b></font> systems occupied by <font color="white"><b>{{faction}}</b></font>',
        "warzone.description.nothingSelected": "Click a system for more information",
        "warzone.description.notPartOfWarzone": "This system is not part of the warzone.",
        "warzone.adjacency.format": "This system is a {{adjacencyStatus}}.",
        "warzone.adjacency.frontline": "Frontline",
        "warzone.adjacency.secondline": "Command Operations",
        "warzone.adjacency.backline": "Rearguard",
        "warzone.advantage.header": "Advantage",
        "warzone.advantage.objectives": "Completed Objectives: {{amount}}%",
        "warzone.advantage.adjacency": "Neighboring Systems: {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}} has a {{advantageAmount}}% net advantage bonus",
        "warzone.advantage.noAdvantage": "Neither side has the advantage",
        "warzone.table.name": "System",
        "warzone.table.constellation": "Constellation",
        "warzone.table.contested": "Contested",
        "warzone.table.advantage": "Advantage",
        "warzone.table.adjacency": "Status",
        "warzone.tab.table": "Details",
        "warzone.tab.map": "Control Map",
        "warzone.leaderboard.rank": "Current rank",
        "warzone.notEnlisted": "Not enlisted",
        "warzone.leaderboard.points": "Victory Points",
        "warzone.leaderboard.kills": "Kills",
        "warzone.leaderboard.tooltip.points.yesterday": "Victory Points Yesterday",
        "warzone.leaderboard.tooltip.points.lastWeek": "Victory Points Last Week",
        "warzone.leaderboard.tooltip.points.total": "Victory Points Total",
        "warzone.leaderboard.tooltip.kills.yesterday": "Kills Yesterday",
        "warzone.leaderboard.tooltip.kills.lastWeek": "Kills In the Last Week",
        "warzone.leaderboard.tooltip.kills.total": "Kills Total",
        "warzone.ranks.gallente.0": "Federation Minuteman",
        "warzone.ranks.gallente.1": "Defender Lieutenant",
        "warzone.ranks.gallente.2": "Guardian Lieutenant",
        "warzone.ranks.gallente.3": "Lieutenant Sentinel",
        "warzone.ranks.gallente.4": "Shield Commander",
        "warzone.ranks.gallente.5": "Aegis Commander",
        "warzone.ranks.gallente.6": "Vice Commander",
        "warzone.ranks.gallente.7": "Major General",
        "warzone.ranks.gallente.8": "Lieutenant General",
        "warzone.ranks.gallente.9": "Luminaire General",
        "warzone.ranks.amarr.0": "Paladin Crusader",
        "warzone.ranks.amarr.1": "Templar Lieutenant",
        "warzone.ranks.amarr.2": "Cardinal Lieutenant",
        "warzone.ranks.amarr.3": "Arch Lieutenant",
        "warzone.ranks.amarr.4": "Imperial Major",
        "warzone.ranks.amarr.5": "Marshal Commander",
        "warzone.ranks.amarr.6": "Imperator Commander",
        "warzone.ranks.amarr.7": "Tribunus Colonel",
        "warzone.ranks.amarr.8": "Legatus Commodore",
        "warzone.ranks.amarr.9": "Divine Commodore",
        "warzone.ranks.caldari.0": "Protectorate Ensign",
        "warzone.ranks.caldari.1": "Second Lieutenant",
        "warzone.ranks.caldari.2": "First Lieutenant",
        "warzone.ranks.caldari.3": "Captain",
        "warzone.ranks.caldari.4": "Major",
        "warzone.ranks.caldari.5": "Lieutenant Colonel",
        "warzone.ranks.caldari.6": "Colonel",
        "warzone.ranks.caldari.7": "Wing Commander",
        "warzone.ranks.caldari.8": "Strike Commander",
        "warzone.ranks.caldari.9": "Brigadier General",
        "warzone.ranks.minmatar.0": "Nation Warrior",
        "warzone.ranks.minmatar.1": "Spike Lieutenant",
        "warzone.ranks.minmatar.2": "Spear Lieutenant",
        "warzone.ranks.minmatar.3": "Venge Captain",
        "warzone.ranks.minmatar.4": "Lance Commander",
        "warzone.ranks.minmatar.5": "Blade Commander",
        "warzone.ranks.minmatar.6": "Talon Commander",
        "warzone.ranks.minmatar.7": "Voshud Major",
        "warzone.ranks.minmatar.8": "Matar Colonel",
        "warzone.ranks.minmatar.9": "Valklear General",
        "warzone.ranks.angel.0": "Ishim Associate",
        "warzone.ranks.angel.1": "Kerubim Guerilla",
        "warzone.ranks.angel.2": "Malakim Soldier",
        "warzone.ranks.angel.3": "Serafim Captain",
        "warzone.ranks.angel.4": "Elohim Sublord",
        "warzone.ranks.angel.5": "Ophanim Crimelord",
        "warzone.ranks.angel.6": "Yazatim Overlord",
        "warzone.ranks.angel.7": "Principal Warlord",
        "warzone.ranks.angel.8": "Throne Eminence",
        "warzone.ranks.angel.9": "Domination Kleptarch",
        "warzone.ranks.guristas.0": "Bandit Scout",
        "warzone.ranks.guristas.1": "Corsair Hunter",
        "warzone.ranks.guristas.2": "Commando Freebooter",
        "warzone.ranks.guristas.3": "Ace Pirate",
        "warzone.ranks.guristas.4": "Hijack Commander",
        "warzone.ranks.guristas.5": "Heist Crew Chief",
        "warzone.ranks.guristas.6": "Raid Wing Captain",
        "warzone.ranks.guristas.7": "Dread Commodore",
        "warzone.ranks.guristas.8": "Insurgent Admiral",
        "warzone.ranks.guristas.9": "Guri Fleet Admiral",
        "warzone.arcgoals.title.stellar_tech_research": "Stellar Tech Research",
        "warzone.arcgoals.title.relay_tech_research": "Relay Tech Research",
        "warzone.arcgoals.title.construction": "Shipcaster Construction",
        "warzone.arcgoals.completed": "Completed"
      }
    },
    de: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "Minmatar Republic",
        "warzone.faction.amarr": "Amarr Empire",
        "warzone.faction.gallente": "Gallente Federation",
        "warzone.faction.caldari": "Caldari State",
        "warzone.faction.angel": "Angel Cartel",
        "warzone.faction.guristas": "Guristas Pirates",
        "warzone.faction-short.minmatar": "Minmatar",
        "warzone.faction-short.amarr": "Amarr",
        "warzone.faction-short.gallente": "Gallente",
        "warzone.faction-short.caldari": "Caldari",
        "warzone.faction-short.angel": "Angel Cartel",
        "warzone.faction-short.guristas": "Guristas Pirates",
        "warzone.corporation.gallente": "Federal Defense Union",
        "warzone.corporation.caldari": "State Protectorate",
        "warzone.corporation.amarr": "24th Imperial Crusade",
        "warzone.corporation.minmatar": "Tribal Liberation Force",
        "warzone.corporation.angel": "Angel Cartel",
        "warzone.corporation.guristas": "Guristas Pirates",
        "warzone.tooltip.progress": '<font color="white"><b>{{count}}</b></font> Systeme besetzt von <font color="white"><b>{{faction}}</b></font>',
        "warzone.description.nothingSelected": "Klicken Sie f\xFCr weitere Informationen auf ein System",
        "warzone.description.notPartOfWarzone": "Dieses System geh\xF6rt nicht zum Kriegsgebiet",
        "warzone.adjacency.format": "Das System ist ein {{adjacencyStatus}}.",
        "warzone.adjacency.frontline": "Kriegsfront",
        "warzone.adjacency.secondline": "Zweitfront",
        "warzone.adjacency.backline": "Drittfront",
        "warzone.advantage.header": "Vorteil",
        "warzone.advantage.objectives": "Abgeschlossene Ziele: {{amount}}%",
        "warzone.advantage.adjacency": "Nachbarsysteme: {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}} hat einen Netto-Vorteilsbonus von {{advantageAmount}}",
        "warzone.advantage.noAdvantage": "Keine Seite ist im Vorteil",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>Nicht umk\xE4mpft</b>",
        "warzone.status.stable": "<b>Stabil</b>",
        "warzone.status.contested": "<b>Umk\xE4mpft</b>",
        "warzone.status.vulnerable": '<font color="red"><b>Verwundbar</b></font>',
        "warzone.table.name": "System",
        "warzone.table.constellation": "Konstellation",
        "warzone.table.contested": "Umk\xE4mpft",
        "warzone.table.advantage": "Vorteil",
        "warzone.table.adjacency": "Status",
        "warzone.tab.table": "Details",
        "warzone.tab.map": "Kontrollkarte",
        "warzone.leaderboard.points": "Siegpunkte",
        "warzone.leaderboard.kills": "Absch\xFCsse",
        "warzone.leaderboard.enlisted": "Mitglied der {{faction}}",
        "warzone.leaderboard.rank": "Aktueller Rang",
        "warzone.notEnlisted": "Nicht eingeschrieben",
        "warzone.leaderboard.tooltip.points.yesterday": "Siegpunkte von gestern",
        "warzone.leaderboard.tooltip.points.lastWeek": "Siegpunkte der letzten Woche",
        "warzone.leaderboard.tooltip.points.total": "Siegpunkte gesamt",
        "warzone.leaderboard.tooltip.kills.yesterday": "Absch\xFCsse von gestern",
        "warzone.leaderboard.tooltip.kills.lastWeek": "Absch\xFCsse der letzten Woche",
        "warzone.leaderboard.tooltip.kills.total": "Absch\xFCsse gesamt",
        "warzone.ranks.gallente.0": "F\xF6deraler Minuteman",
        "warzone.ranks.gallente.1": "Leutnant der Verteidigung",
        "warzone.ranks.gallente.2": "Leutnant der Garde",
        "warzone.ranks.gallente.3": "Leutnant der Wache",
        "warzone.ranks.gallente.4": "Schild-Kommandant",
        "warzone.ranks.gallente.5": "Aegis-Kommandant",
        "warzone.ranks.gallente.6": "Vizekommandant",
        "warzone.ranks.gallente.7": "Majorgeneral",
        "warzone.ranks.gallente.8": "Leutnantgeneral",
        "warzone.ranks.gallente.9": "General des Lichts",
        "warzone.ranks.amarr.0": "Paladin-Kreuzritter",
        "warzone.ranks.amarr.1": "Templer-Leutnant",
        "warzone.ranks.amarr.2": "Kardinal-Leutnant",
        "warzone.ranks.amarr.3": "Erz-Leutnant",
        "warzone.ranks.amarr.4": "Imperialer Major",
        "warzone.ranks.amarr.5": "Marschallkommandant",
        "warzone.ranks.amarr.6": "Imperatorkommandant",
        "warzone.ranks.amarr.7": "Anf\xFChrender Oberst",
        "warzone.ranks.amarr.8": "Gesandter Flottenadmiral",
        "warzone.ranks.amarr.9": "G\xF6ttlicher Flottenadmiral",
        "warzone.ranks.caldari.0": "Protektoratsf\xE4hnrich",
        "warzone.ranks.caldari.1": "Zweiter Leutnant",
        "warzone.ranks.caldari.2": "Erster Leutnant",
        "warzone.ranks.caldari.3": "Hauptmann",
        "warzone.ranks.caldari.4": "Major",
        "warzone.ranks.caldari.5": "Oberstleutnant",
        "warzone.ranks.caldari.6": "Oberst",
        "warzone.ranks.caldari.7": "Geschwaderkommandeur",
        "warzone.ranks.caldari.8": "Staffelkommandant",
        "warzone.ranks.caldari.9": "Brigadegeneral",
        "warzone.ranks.minmatar.0": "Nationskrieger",
        "warzone.ranks.minmatar.1": "Spie\xDFleutnant",
        "warzone.ranks.minmatar.2": "Speerleutnant",
        "warzone.ranks.minmatar.3": "Rachehauptmann",
        "warzone.ranks.minmatar.4": "Lanzenkommandant",
        "warzone.ranks.minmatar.5": "Klingenkommandant",
        "warzone.ranks.minmatar.6": "Klauenkommandant",
        "warzone.ranks.minmatar.7": "Voshud-Major",
        "warzone.ranks.minmatar.8": "Matar-Oberst",
        "warzone.ranks.minmatar.9": "Valklear-General"
      }
    },
    es: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "Rep\xFAblica Minmatar",
        "warzone.faction.amarr": "Imperio Amarr",
        "warzone.faction.gallente": "Federaci\xF3n Gallente",
        "warzone.faction.caldari": "Estado Caldari",
        "warzone.faction.angel": "C\xE1rtel de los \xC1ngeles",
        "warzone.faction.guristas": "Piratas Guristas",
        "warzone.faction-short.minmatar": "Minmatar",
        "warzone.faction-short.amarr": "Amarr",
        "warzone.faction-short.gallente": "Gallente",
        "warzone.faction-short.caldari": "Caldari",
        "warzone.faction-short.angel": "C\xE1rtel de los \xC1ngeles",
        "warzone.faction-short.guristas": "Piratas Guristas",
        "warzone.corporation.gallente": "Uni\xF3n de Defensa Federal",
        "warzone.corporation.caldari": "Protectorado del Estado",
        "warzone.corporation.amarr": "24.\xAA Cruzada Imperial",
        "warzone.corporation.minmatar": "Fuerza Tribal de Liberaci\xF3n",
        "warzone.corporation.angel": "C\xE1rtel de los \xC1ngeles",
        "warzone.corporation.guristas": "Piratas Guristas",
        "warzone.tooltip.progress": '<font color="white"><b>{{count}}</b></font> sistemas ocupados por <font color="white"><b>{{faction}}</b></font>',
        "warzone.description.nothingSelected": "Haz clic en un sistema para obtener m\xE1s informaci\xF3n.",
        "warzone.description.notPartOfWarzone": "Este sistema no forma parte de la zona de guerra.",
        "warzone.adjacency.format": "Este sistema es un {{adjacencyStatus}}.",
        "warzone.adjacency.frontline": "Primera l\xEDnea",
        "warzone.adjacency.secondline": "Operaciones de mando",
        "warzone.adjacency.backline": "Retaguardia",
        "warzone.advantage.header": "Ventaja",
        "warzone.advantage.objectives": "Objetivos completados: {{amount}}%",
        "warzone.advantage.adjacency": "Sistemas colindantes: {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}} tiene una bonificaci\xF3n de ventaja neta del {{advantageAmount}}%.",
        "warzone.advantage.noAdvantage": "Ning\xFAn bando tiene la ventaja.",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>No disputado</b>",
        "warzone.status.stable": "<b>Estable</b>",
        "warzone.status.contested": "<b>En disputa</b>",
        "warzone.status.vulnerable": '<font color="red"><b>Vulnerable</b></font>',
        "warzone.table.name": "Sistema",
        "warzone.table.constellation": "Constelaci\xF3n",
        "warzone.table.contested": "En disputa",
        "warzone.table.advantage": "Ventaja",
        "warzone.table.adjacency": "Estado",
        "warzone.tab.table": "Detalles",
        "warzone.tab.map": "Mapa de control",
        "warzone.leaderboard.points": "Puntos de victoria",
        "warzone.leaderboard.kills": "Muertes",
        "warzone.leaderboard.enlisted": "Se ha alistado en {{faction}}",
        "warzone.leaderboard.rank": "Rango actual",
        "warzone.notEnlisted": "Sin alistar",
        "warzone.leaderboard.tooltip.points.yesterday": "Puntos de victoria (ayer)",
        "warzone.leaderboard.tooltip.points.lastWeek": "Puntos de victoria (semana pasada)",
        "warzone.leaderboard.tooltip.points.total": "Total de puntos de victoria",
        "warzone.leaderboard.tooltip.kills.yesterday": "Muertes (ayer)",
        "warzone.leaderboard.tooltip.kills.lastWeek": "Muertes (semana pasada)",
        "warzone.leaderboard.tooltip.kills.total": "Muertes totales",
        "warzone.ranks.gallente.0": "Soldado de milicia de la Federaci\xF3n",
        "warzone.ranks.gallente.1": "Teniente defensor",
        "warzone.ranks.gallente.2": "Teniente guardi\xE1n",
        "warzone.ranks.gallente.3": "Teniente centinela",
        "warzone.ranks.gallente.4": "Comandante escudo",
        "warzone.ranks.gallente.5": "Comandante aegis",
        "warzone.ranks.gallente.6": "Vicecomandante",
        "warzone.ranks.gallente.7": "Mayor general",
        "warzone.ranks.gallente.8": "Teniente general",
        "warzone.ranks.gallente.9": "General de Luminaire",
        "warzone.ranks.amarr.0": "Palad\xEDn cruzado",
        "warzone.ranks.amarr.1": "Teniente templario",
        "warzone.ranks.amarr.2": "Teniente cardenal",
        "warzone.ranks.amarr.3": "Architeniente",
        "warzone.ranks.amarr.4": "Mayor imperial",
        "warzone.ranks.amarr.5": "Comandante mariscal",
        "warzone.ranks.amarr.6": "Comandante imperator",
        "warzone.ranks.amarr.7": "Coronel tribuno",
        "warzone.ranks.amarr.8": "Comodoro legado",
        "warzone.ranks.amarr.9": "Comodoro divino",
        "warzone.ranks.caldari.0": "Alf\xE9rez del Protectorado",
        "warzone.ranks.caldari.1": "Teniente segundo",
        "warzone.ranks.caldari.2": "Teniente primero",
        "warzone.ranks.caldari.3": "Capit\xE1n",
        "warzone.ranks.caldari.4": "Mayor",
        "warzone.ranks.caldari.5": "Teniente coronel",
        "warzone.ranks.caldari.6": "Coronel",
        "warzone.ranks.caldari.7": "Comandante de ala",
        "warzone.ranks.caldari.8": "Comandante de asalto",
        "warzone.ranks.caldari.9": "General de brigada",
        "warzone.ranks.minmatar.0": "Guerrero de la naci\xF3n",
        "warzone.ranks.minmatar.1": "Teniente astilla",
        "warzone.ranks.minmatar.2": "Teniente lanza",
        "warzone.ranks.minmatar.3": "Capit\xE1n vengador",
        "warzone.ranks.minmatar.4": "Comandante lanza",
        "warzone.ranks.minmatar.5": "Comandante espada",
        "warzone.ranks.minmatar.6": "Comandante garra",
        "warzone.ranks.minmatar.7": "Mayor voshud",
        "warzone.ranks.minmatar.8": "Coronel matar",
        "warzone.ranks.minmatar.9": "General valklear"
      }
    },
    fr: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "R\xE9publique minmatar",
        "warzone.faction.amarr": "Empire amarr",
        "warzone.faction.gallente": "F\xE9d\xE9ration gallente",
        "warzone.faction.caldari": "\xC9tat caldari",
        "warzone.faction.angel": "Cartel angel",
        "warzone.faction.guristas": "Pirates guristas",
        "warzone.faction-short.minmatar": "Minmatar",
        "warzone.faction-short.amarr": "Amarr",
        "warzone.faction-short.gallente": "Gallente",
        "warzone.faction-short.caldari": "Caldari",
        "warzone.faction-short.angel": "Cartel angel",
        "warzone.faction-short.guristas": "Pirates guristas",
        "warzone.corporation.gallente": "Federal Defense Union",
        "warzone.corporation.caldari": "State Protectorate",
        "warzone.corporation.amarr": "24th Imperial Crusade",
        "warzone.corporation.minmatar": "Tribal Liberation Force",
        "warzone.corporation.angel": "Cartel angel",
        "warzone.corporation.guristas": "Pirates guristas",
        "warzone.tooltip.progress": '<font color="white"> <b>{{count}}</b></font> syst\xE8mes occup\xE9s par <font color="white"> <b>{{faction}}</b></font>',
        "warzone.description.nothingSelected": "Cliquez sur un syst\xE8me pour plus d'informations",
        "warzone.description.notPartOfWarzone": "Ce syst\xE8me ne fait pas partie de la zone de guerre",
        "warzone.adjacency.format": "Statut du syst\xE8me: {{adjacencyStatus}}.",
        "warzone.adjacency.frontline": "Front",
        "warzone.adjacency.secondline": "Op\xE9rations de commandement",
        "warzone.adjacency.backline": "Arri\xE8re-garde",
        "warzone.advantage.header": "Avantage",
        "warzone.advantage.objectives": "Completed Objectives: {{amount}}%",
        "warzone.advantage.adjacency": "Neighboring Systems: {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}} a un bonus d''avantage net de {{advantageAmount}}%",
        "warzone.advantage.noAdvantage": "Aucun des camps n'a l'avantage",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>Non contest\xE9</b>",
        "warzone.status.stable": "<b>Stable</b>",
        "warzone.status.contested": "<b>Contest\xE9</b>",
        "warzone.status.vulnerable": '<font color="red"><b>Vuln\xE9rable</b></font>',
        "warzone.table.name": "Syst\xE8me",
        "warzone.table.constellation": "Constellation",
        "warzone.table.contested": "Contest\xE9",
        "warzone.table.advantage": "Avantage",
        "warzone.table.adjacency": "Statut",
        "warzone.tab.table": "D\xE9tails",
        "warzone.tab.map": "Carte de contr\xF4le",
        "warzone.leaderboard.points": "Points de victoire",
        "warzone.leaderboard.kills": "Destructions",
        "warzone.leaderboard.enlisted": "Engagement avec  {{faction}}",
        "warzone.leaderboard.rank": "Grade actuel",
        "warzone.leaderboard.tooltip.points.yesterday": "Points de victoire hier",
        "warzone.leaderboard.tooltip.points.lastWeek": "Points de victoire la semaine derni\xE8re",
        "warzone.leaderboard.tooltip.points.total": "Total de points de victoire",
        "warzone.leaderboard.tooltip.kills.yesterday": "Victimes hier",
        "warzone.leaderboard.tooltip.kills.lastWeek": "Victimes la semaine derni\xE8re",
        "warzone.leaderboard.tooltip.kills.total": "Total de victimes",
        "warzone.notEnlisted": "Pas d'engagement",
        "warzone.ranks.gallente.0": "H\xE9raut de la F\xE9d\xE9ration",
        "warzone.ranks.gallente.1": "Lieutenant d\xE9fenseur",
        "warzone.ranks.gallente.2": "Lieutenant gardien",
        "warzone.ranks.gallente.3": "Lieutenant sentinelle",
        "warzone.ranks.gallente.4": "Commandant bouclier",
        "warzone.ranks.gallente.5": "Commandant aegis",
        "warzone.ranks.gallente.6": "Vice-commandant",
        "warzone.ranks.gallente.7": "Major-g\xE9n\xE9ral",
        "warzone.ranks.gallente.8": "Lieutenant-g\xE9n\xE9ral",
        "warzone.ranks.gallente.9": "G\xE9n\xE9ral luminaire",
        "warzone.ranks.amarr.0": "Crois\xE9 paladin",
        "warzone.ranks.amarr.1": "Lieutenant templier",
        "warzone.ranks.amarr.2": "Lieutenant cardinal",
        "warzone.ranks.amarr.3": "Lieutenant sup\xE9rieur",
        "warzone.ranks.amarr.4": "Major imp\xE9rial",
        "warzone.ranks.amarr.5": "Commandant mar\xE9chal",
        "warzone.ranks.amarr.6": "Commandant imperator",
        "warzone.ranks.amarr.7": "Colonel tribunus",
        "warzone.ranks.amarr.8": "Commodore legatus",
        "warzone.ranks.amarr.9": "Commodore divin",
        "warzone.ranks.caldari.0": "Insigne du protectorat",
        "warzone.ranks.caldari.1": "Second lieutenant",
        "warzone.ranks.caldari.2": "Premier lieutenant",
        "warzone.ranks.caldari.3": "Capitaine",
        "warzone.ranks.caldari.4": "Major",
        "warzone.ranks.caldari.5": "Lieutenant-colonel",
        "warzone.ranks.caldari.6": "Colonel",
        "warzone.ranks.caldari.7": "Commandant d'unit\xE9",
        "warzone.ranks.caldari.8": "Commandant d'assaut",
        "warzone.ranks.caldari.9": "Brigadier-g\xE9n\xE9ral",
        "warzone.ranks.minmatar.0": "Guerrier de la Nation",
        "warzone.ranks.minmatar.1": "Lieutenant piquier",
        "warzone.ranks.minmatar.2": "Lieutenant lancier",
        "warzone.ranks.minmatar.3": "Capitaine vengeur",
        "warzone.ranks.minmatar.4": "Commandant uhlan",
        "warzone.ranks.minmatar.5": "Commandant lame",
        "warzone.ranks.minmatar.6": "Commandant griffe",
        "warzone.ranks.minmatar.7": "Major voshud",
        "warzone.ranks.minmatar.8": "Colonel matar",
        "warzone.ranks.minmatar.9": "G\xE9n\xE9ral valklear"
      }
    },
    ja: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "\u30DF\u30F3\u30DE\u30BF\u30FC\u5171\u548C\u56FD",
        "warzone.faction.amarr": "\u30A2\u30DE\u30FC\u5E1D\u56FD",
        "warzone.faction.gallente": "\u30AC\u30EC\u30F3\u30C6\u9023\u90A6",
        "warzone.faction.caldari": "\u30AB\u30EB\u30C0\u30EA\u9023\u5408",
        "warzone.faction.angel": "\u30A8\u30F3\u30B8\u30A7\u30EB\u30AB\u30EB\u30C6\u30EB",
        "warzone.faction.guristas": "\u30AC\u30EA\u30B9\u30BF\u30B9\u6D77\u8CCA\u56E3",
        "warzone.faction-short.minmatar": "\u30DF\u30F3\u30DE\u30BF\u30FC",
        "warzone.faction-short.amarr": "\u30A2\u30DE\u30FC",
        "warzone.faction-short.gallente": "\u30AC\u30EC\u30F3\u30C6",
        "warzone.faction-short.caldari": "\u30AB\u30EB\u30C0\u30EA",
        "warzone.faction-short.angel": "\u30A8\u30F3\u30B8\u30A7\u30EB\u30AB\u30EB\u30C6\u30EB",
        "warzone.faction-short.guristas": "\u30AC\u30EA\u30B9\u30BF\u30B9\u6D77\u8CCA\u56E3",
        "warzone.corporation.gallente": "\u9023\u90A6\u9632\u885B\u540C\u76DF",
        "warzone.corporation.caldari": "\u9023\u5408\u30D7\u30ED\u30C6\u30AF\u30C8\u30EC\u30A4\u30C8",
        "warzone.corporation.amarr": "\u7B2C24\u968A\u5E1D\u56FD\u5341\u5B57\u8ECD",
        "warzone.corporation.minmatar": "\u9023\u76DF\u81EA\u7531\u8ECD",
        "warzone.corporation.angel": "\u30A8\u30F3\u30B8\u30A7\u30EB\u30AB\u30EB\u30C6\u30EB",
        "warzone.corporation.guristas": "\u30AC\u30EA\u30B9\u30BF\u30B9\u6D77\u8CCA\u56E3",
        "warzone.tooltip.progress": "<font color=\"white\"><b>{{faction}}</b></font>\u306B\u3088\u308A\u3001<font color=\"white\"><b>{{count}}</b></font>\u500B\u306E\u30B7\u30B9\u30C6\u30E0\u304C\u5360\u9818\u3055\u308C\u3066\u3044\u308B",
        "warzone.description.nothingSelected": "\u30B7\u30B9\u30C6\u30E0\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8A73\u7D30\u3092\u8868\u793A",
        "warzone.description.notPartOfWarzone": "\u3053\u306E\u30B7\u30B9\u30C6\u30E0\u306F\u6226\u5834\u306B\u542B\u307E\u308C\u3066\u3044\u307E\u305B\u3093",
        "warzone.adjacency.format": "\u3053\u306E\u30B7\u30B9\u30C6\u30E0\u306F{{adjacencyStatus}}\u3067\u3059\u3002",
        "warzone.adjacency.frontline": "\u30D5\u30ED\u30F3\u30C8\u30E9\u30A4\u30F3",
        "warzone.adjacency.secondline": "\u30B3\u30DE\u30F3\u30C9\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "warzone.adjacency.backline": "\u30EA\u30A2\u30AC\u30FC\u30C9",
        "warzone.advantage.header": "\u30A2\u30C9\u30D0\u30F3\u30C6\u30FC\u30B8",
        "warzone.advantage.objectives": "\u5B8C\u4E86\u3057\u305F\u76EE\u6A19\uFF1A{{amount}}%",
        "warzone.advantage.adjacency": "\u96A3\u63A5\u30B7\u30B9\u30C6\u30E0\uFF1A {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}}\u304C{{advantageAmount}}%\u306E\u57FA\u790E\u30A2\u30C9\u30D0\u30F3\u30C6\u30FC\u30B8\u30DC\u30FC\u30CA\u30B9\u3092\u6301\u3063\u3066\u3044\u307E\u3059",
        "warzone.advantage.noAdvantage": "\u3069\u3061\u3089\u306B\u3082\u30A2\u30C9\u30D0\u30F3\u30C6\u30FC\u30B8\u304C\u3042\u308A\u307E\u305B\u3093",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>\u7D1B\u4E89\u306A\u3057</b>",
        "warzone.status.stable": "<b>\u5B89\u5B9A</b>",
        "warzone.status.contested": "<b>\u7D1B\u4E89\u4E2D</b>",
        "warzone.status.vulnerable": "<font color=\"red\"><b>\u653B\u6483\u53EF\u80FD</b></font>",
        "warzone.table.name": "\u30B7\u30B9\u30C6\u30E0",
        "warzone.table.constellation": "\u30B3\u30F3\u30B9\u30C6\u30EC\u30FC\u30B7\u30E7\u30F3",
        "warzone.table.contested": "\u7D1B\u4E89\u4E2D",
        "warzone.table.advantage": "\u30A2\u30C9\u30D0\u30F3\u30C6\u30FC\u30B8",
        "warzone.table.adjacency": "\u30B9\u30C6\u30FC\u30BF\u30B9",
        "warzone.tab.table": "\u8A73\u7D30",
        "warzone.tab.map": "\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB\u30DE\u30C3\u30D7",
        "warzone.leaderboard.points": "\u52DD\u5229\u30DD\u30A4\u30F3\u30C8",
        "warzone.leaderboard.kills": "\u6483\u589C\u6570",
        "warzone.leaderboard.enlisted": "{{faction}}\u306B\u53C2\u52A0",
        "warzone.leaderboard.rank": "\u73FE\u5728\u306E\u30E9\u30F3\u30AF",
        "warzone.notEnlisted": "\u672A\u53C2\u52A0",
        "warzone.leaderboard.tooltip.points.yesterday": "\u6628\u65E5\u306E\u52DD\u5229\u30DD\u30A4\u30F3\u30C8",
        "warzone.leaderboard.tooltip.points.lastWeek": "\u5148\u9031\u306E\u52DD\u5229\u30DD\u30A4\u30F3\u30C8",
        "warzone.leaderboard.tooltip.points.total": "\u7DCF\u52DD\u5229\u30DD\u30A4\u30F3\u30C8",
        "warzone.leaderboard.tooltip.kills.yesterday": "\u6628\u65E5\u306E\u6483\u589C\u6570",
        "warzone.leaderboard.tooltip.kills.lastWeek": "\u5148\u9031\u306E\u6483\u589C\u6570",
        "warzone.leaderboard.tooltip.kills.total": "\u7DCF\u6483\u589C\u6570",
        "warzone.ranks.gallente.0": "\u9023\u90A6\u6C11\u5175",
        "warzone.ranks.gallente.1": "\u30C7\u30A3\u30D5\u30A7\u30F3\u30C0\u30FC\u4E2D\u5C09",
        "warzone.ranks.gallente.2": "\u30AC\u30FC\u30C7\u30A3\u30A2\u30F3\u4E2D\u5C09",
        "warzone.ranks.gallente.3": "\u4E2D\u5C09\u30BB\u30F3\u30C1\u30CD\u30EB",
        "warzone.ranks.gallente.4": "\u30B7\u30FC\u30EB\u30C9\u53F8\u4EE4\u5B98",
        "warzone.ranks.gallente.5": "\u30A4\u30FC\u30B8\u30B9\u53F8\u4EE4\u5B98",
        "warzone.ranks.gallente.6": "\u526F\u53F8\u4EE4\u5B98",
        "warzone.ranks.gallente.7": "\u5C11\u5C06",
        "warzone.ranks.gallente.8": "\u4E2D\u5C06",
        "warzone.ranks.gallente.9": "\u30EB\u30DF\u30CD\u30FC\u30EB\u5C06\u8ECD",
        "warzone.ranks.amarr.0": "\u30D1\u30E9\u30C7\u30A3\u30F3\u30AF\u30EB\u30BB\u30A4\u30C0\u30FC",
        "warzone.ranks.amarr.1": "\u30C6\u30F3\u30D7\u30E9\u30FC\u4E2D\u5C09",
        "warzone.ranks.amarr.2": "\u30AB\u30FC\u30C7\u30A3\u30CA\u30EB\u4E2D\u5C09",
        "warzone.ranks.amarr.3": "\u30A2\u30FC\u30AF\u4E2D\u5C09",
        "warzone.ranks.amarr.4": "\u5E1D\u56FD\u5C11\u4F50",
        "warzone.ranks.amarr.5": "\u30DE\u30FC\u30B7\u30E3\u30EB\u53F8\u4EE4\u5B98",
        "warzone.ranks.amarr.6": "\u5049\u5927\u306A\u53F8\u4EE4\u5B98",
        "warzone.ranks.amarr.7": "\u30C8\u30EA\u30D6\u30CA\u30B9\u5927\u4F50",
        "warzone.ranks.amarr.8": "\u8ECD\u56E3\u9577\u6D77\u8ECD\u51C6\u5C06",
        "warzone.ranks.amarr.9": "\u30C7\u30A3\u30D0\u30A4\u30F3\u6D77\u8ECD\u51C6\u5C06",
        "warzone.ranks.caldari.0": "\u4FDD\u8B77\u5C11\u5C09",
        "warzone.ranks.caldari.1": "\u5C11\u5C09",
        "warzone.ranks.caldari.2": "\u4E2D\u5C09",
        "warzone.ranks.caldari.3": "\u8266\u9577",
        "warzone.ranks.caldari.4": "\u5C11\u4F50",
        "warzone.ranks.caldari.5": "\u4E2D\u4F50",
        "warzone.ranks.caldari.6": "\u5927\u4F50",
        "warzone.ranks.caldari.7": "\u30A6\u30A3\u30F3\u30B0\u53F8\u4EE4\u5B98",
        "warzone.ranks.caldari.8": "\u30B9\u30C8\u30E9\u30A4\u30AF\u53F8\u4EE4\u5B98",
        "warzone.ranks.caldari.9": "\u51C6\u5C06",
        "warzone.ranks.minmatar.0": "\u30CD\u30FC\u30B7\u30E7\u30F3\u6226\u58EB",
        "warzone.ranks.minmatar.1": "\u30B9\u30D1\u30A4\u30AF\u4E2D\u5C09",
        "warzone.ranks.minmatar.2": "\u30B9\u30D4\u30A2\u4E2D\u5C09",
        "warzone.ranks.minmatar.3": "\u30D9\u30F3\u30B8\u8266\u9577",
        "warzone.ranks.minmatar.4": "\u30E9\u30F3\u30B9\u53F8\u4EE4\u5B98",
        "warzone.ranks.minmatar.5": "\u30D6\u30EC\u30A4\u30C9\u53F8\u4EE4\u5B98",
        "warzone.ranks.minmatar.6": "\u30BF\u30ED\u30F3\u53F8\u4EE4\u5B98",
        "warzone.ranks.minmatar.7": "\u30F4\u30A9\u30B7\u30E5\u30C9\u5C11\u4F50",
        "warzone.ranks.minmatar.8": "\u30DE\u30BF\u30FC\u30EB\u5927\u4F50",
        "warzone.ranks.minmatar.9": "\u30F4\u30A9\u30FC\u30AF\u30EA\u30A2\u5C06\u8ECD"
      }
    },
    ko: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "\uBBFC\uB9C8\uD0C0 \uACF5\uD654\uAD6D",
        "warzone.faction.amarr": "\uC544\uB9C8\uB974 \uC81C\uAD6D",
        "warzone.faction.gallente": "\uAC08\uB780\uD14C \uC5F0\uBC29",
        "warzone.faction.caldari": "\uCE7C\uB2E4\uB9AC \uC5F0\uD569",
        "warzone.faction.angel": "\uC5D4\uC824 \uCE74\uB974\uD154",
        "warzone.faction.guristas": "\uAD6C\uB9AC\uC2A4\uD0C0\uC2A4 \uD574\uC801\uB2E8",
        "warzone.faction-short.minmatar": "\uBBFC\uB9C8\uD0C0",
        "warzone.faction-short.amarr": "\uC544\uB9C8\uB974",
        "warzone.faction-short.gallente": "\uAC08\uB780\uD14C",
        "warzone.faction-short.caldari": "\uCE7C\uB2E4\uB9AC",
        "warzone.faction-short.angel": "\uC5D4\uC824 \uCE74\uB974\uD154",
        "warzone.faction-short.guristas": "\uAD6C\uB9AC\uC2A4\uD0C0\uC2A4 \uD574\uC801\uB2E8",
        "warzone.corporation.gallente": "\uC5F0\uBC29 \uBC29\uC704 \uC5F0\uD569",
        "warzone.corporation.caldari": "\uC5F0\uD569 \uBC29\uC704\uB300",
        "warzone.corporation.amarr": "\uC81C24 \uD06C\uB8E8\uC138\uC774\uB4DC \uC81C\uAD6D \uD568\uB300",
        "warzone.corporation.minmatar": "\uBD80\uC871\uD574\uBC29\uC804\uC120",
        "warzone.corporation.angel": "\uC5D4\uC824 \uCE74\uB974\uD154",
        "warzone.corporation.guristas": "\uAD6C\uB9AC\uC2A4\uD0C0\uC2A4 \uD574\uC801\uB2E8",
        "warzone.tooltip.progress": "<font color=\"white\"><b>{{count}}</b></font> \uC131\uACC4\uB97C <font color=\"white\"><b>{{faction}}</b></font> \uD329\uC158\uC774 \uC810\uB839\uD588\uC2B5\uB2C8\uB2E4",
        "warzone.description.nothingSelected": "\uC131\uACC4\uB97C \uD074\uB9AD\uD574 \uCD94\uAC00 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uC2ED\uC2DC\uC624.",
        "warzone.description.notPartOfWarzone": "\uD574\uB2F9 \uC131\uACC4\uB294 \uAD50\uC804\uC9C0\uC5ED\uC774 \uC544\uB2D9\uB2C8\uB2E4.",
        "warzone.adjacency.format": "{{adjacencyStatus}} \uC0C1\uD0DC\uC758 \uC131\uACC4\uC785\uB2C8\uB2E4.",
        "warzone.adjacency.frontline": "\uC804\uBC29 \uAE30\uC9C0",
        "warzone.adjacency.secondline": "\uC9C0\uD718\uBCF8\uBD80",
        "warzone.adjacency.backline": "\uD6C4\uBC29 \uAE30\uC9C0",
        "warzone.advantage.header": "\uC2B9\uAE30",
        "warzone.advantage.objectives": "\uC644\uB8CC\uB41C \uBAA9\uD45C: {{amount}}%",
        "warzone.advantage.adjacency": "\uC8FC\uBCC0 \uC131\uACC4: {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}} \uD329\uC158\uC758 \uD604\uC7AC \uC2B9\uAE30 \uBCF4\uB108\uC2A4 {{advantageAmount}}%",
        "warzone.advantage.noAdvantage": "\uC2B9\uAE30\uB97C \uC5BB\uC740 \uD329\uC158 \uC5C6\uC74C",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>\uACBD\uC7C1 \uC911\uC774 \uC544\uB2D8</b>",
        "warzone.status.stable": "<b>\uC548\uC815</b>",
        "warzone.status.contested": "<b>\uBD84\uC7C1 \uC911</b>",
        "warzone.status.vulnerable": "<font color=\"red\"><b>\uCDE8\uC57D</b></font>",
        "warzone.table.name": "\uC131\uACC4",
        "warzone.table.constellation": "\uC131\uC88C",
        "warzone.table.contested": "\uBD84\uC7C1 \uC911",
        "warzone.table.advantage": "\uC2B9\uAE30",
        "warzone.table.adjacency": "\uC0C1\uD0DC",
        "warzone.tab.table": "\uC138\uBD80 \uC815\uBCF4",
        "warzone.tab.map": "\uC138\uB825 \uC9C0\uB3C4",
        "warzone.leaderboard.points": "\uC2B9\uB9AC \uD3EC\uC778\uD2B8",
        "warzone.leaderboard.kills": "\uD0AC",
        "warzone.leaderboard.enlisted": "{{faction}} \uC18C\uC18D\uC73C\uB85C \uCC38\uC804",
        "warzone.leaderboard.rank": "\uD604\uC7AC \uACC4\uAE09",
        "warzone.notEnlisted": "\uCC38\uC804\uD558\uC9C0 \uC54A\uC74C",
        "warzone.leaderboard.tooltip.points.yesterday": "\uC2B9\uB9AC \uD3EC\uC778\uD2B8 (1\uC77C \uC804)",
        "warzone.leaderboard.tooltip.points.lastWeek": "\uC9C0\uB09C \uC8FC \uC2B9\uB9AC \uD3EC\uC778\uD2B8",
        "warzone.leaderboard.tooltip.points.total": "\uC804\uCCB4 \uC2B9\uB9AC \uD3EC\uC778\uD2B8",
        "warzone.leaderboard.tooltip.kills.yesterday": "\uD0AC (1\uC77C \uC804)",
        "warzone.leaderboard.tooltip.kills.lastWeek": "\uC9C0\uB09C \uC8FC \uD0AC",
        "warzone.leaderboard.tooltip.kills.total": "\uC804\uCCB4 \uD0AC",
        "warzone.ranks.gallente.0": "\uBBF8\uB2DB\uB9E8",
        "warzone.ranks.gallente.1": "\uB514\uD39C\uB354",
        "warzone.ranks.gallente.2": "\uAC00\uB514\uC5B8",
        "warzone.ranks.gallente.3": "\uC13C\uD2F0\uB110",
        "warzone.ranks.gallente.4": "\uC2E4\uB4DC",
        "warzone.ranks.gallente.5": "\uC774\uC9C0\uC2A4",
        "warzone.ranks.gallente.6": "\uC900\uC7A5",
        "warzone.ranks.gallente.7": "\uC18C\uC7A5",
        "warzone.ranks.gallente.8": "\uC911\uC7A5",
        "warzone.ranks.gallente.9": "\uB300\uC7A5",
        "warzone.ranks.amarr.0": "\uD314\uB77C\uB518",
        "warzone.ranks.amarr.1": "\uD15C\uD50C\uB7EC",
        "warzone.ranks.amarr.2": "\uCE74\uB514\uB110",
        "warzone.ranks.amarr.3": "\uC544\uD06C \uBE44\uC20D",
        "warzone.ranks.amarr.4": "\uD314\uB77C\uB518",
        "warzone.ranks.amarr.5": "\uC544\uCE78",
        "warzone.ranks.amarr.6": "\uC784\uD398\uB77C\uD1A0\uB974",
        "warzone.ranks.amarr.7": "\uD2B8\uB9AC\uBE44\uB204\uC2A4",
        "warzone.ranks.amarr.8": "\uB808\uAC00\uD22C\uC2A4",
        "warzone.ranks.amarr.9": "\uB514\uBC14\uC778",
        "warzone.ranks.caldari.0": "\uD6C8\uB828\uC0DD",
        "warzone.ranks.caldari.1": "\uC18C\uC704",
        "warzone.ranks.caldari.2": "\uC911\uC704",
        "warzone.ranks.caldari.3": "\uB300\uC704",
        "warzone.ranks.caldari.4": "\uC18C\uB839",
        "warzone.ranks.caldari.5": "\uC911\uB839",
        "warzone.ranks.caldari.6": "\uB300\uB839",
        "warzone.ranks.caldari.7": "\uC804\uB300\uC7A5",
        "warzone.ranks.caldari.8": "\uD568\uB300\uC7A5",
        "warzone.ranks.caldari.9": "\uC0AC\uB839\uAD00",
        "warzone.ranks.minmatar.0": "\uC6CC\uB9AC\uC5B4",
        "warzone.ranks.minmatar.1": "\uC2A4\uD30C\uC774\uD06C",
        "warzone.ranks.minmatar.2": "\uC2A4\uD53C\uC5B4",
        "warzone.ranks.minmatar.3": "\uBCA4\uC9C0",
        "warzone.ranks.minmatar.4": "\uB79C\uC2A4",
        "warzone.ranks.minmatar.5": "\uBE14\uB808\uC774\uB4DC",
        "warzone.ranks.minmatar.6": "\uD0C8\uB860",
        "warzone.ranks.minmatar.7": "\uBCF4\uC288\uB4DC",
        "warzone.ranks.minmatar.8": "\uB9C8\uD0C0\uB974",
        "warzone.ranks.minmatar.9": "\uBC1C\uD06C\uB9AC\uC5B4"
      }
    },
    ru: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0438\u043D\u043C\u0430\u0442\u0430\u0440",
        "warzone.faction.amarr": "\u0410\u043C\u0430\u0440\u0440\u0441\u043A\u0430\u044F \u0418\u043C\u043F\u0435\u0440\u0438\u044F",
        "warzone.faction.gallente": "\u0413\u0430\u043B\u043B\u0435\u043D\u0442\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F",
        "warzone.faction.caldari": "\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u041A\u0430\u043B\u0434\u0430\u0440\u0438",
        "warzone.faction.angel": "\xAB\u041A\u0430\u0440\u0442\u0435\u043B\u044C \u0430\u043D\u0433\u0435\u043B\u043E\u0432\xBB",
        "warzone.faction.guristas": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \xAB\u0413\u0443\u0440\u0438\u0441\u0442\u0430\u0441\xBB",
        "warzone.faction-short.minmatar": "\u041C\u0438\u043D\u043C\u0430\u0442\u0430\u0440",
        "warzone.faction-short.amarr": "\u0410\u043C\u0430\u0440\u0440",
        "warzone.faction-short.gallente": "\u0413\u0430\u043B\u043B\u0435\u043D\u0442\u0435",
        "warzone.faction-short.caldari": "\u041A\u0430\u043B\u0434\u0430\u0440\u0438",
        "warzone.faction-short.angel": "\xAB\u041A\u0430\u0440\u0442\u0435\u043B\u044C \u0430\u043D\u0433\u0435\u043B\u043E\u0432\xBB",
        "warzone.faction-short.guristas": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \xAB\u0413\u0443\u0440\u0438\u0441\u0442\u0430\u0441\xBB",
        "warzone.corporation.gallente": "Federal Defense Union",
        "warzone.corporation.caldari": "State Protectorate",
        "warzone.corporation.amarr": "24th Imperial Crusade",
        "warzone.corporation.minmatar": "Tribal Liberation Force",
        "warzone.corporation.angel": "\xAB\u041A\u0430\u0440\u0442\u0435\u043B\u044C \u0430\u043D\u0433\u0435\u043B\u043E\u0432\xBB",
        "warzone.corporation.guristas": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \xAB\u0413\u0443\u0440\u0438\u0441\u0442\u0430\u0441\xBB",
        "warzone.tooltip.progress": "<font color=\"white\"><b>{{faction}}</b></font> \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 \u0441\u0438\u0441\u0442\u0435\u043C\u044B: <font color=\"white\"><b>{{count}}</b></font>",
        "warzone.description.nothingSelected": "\u0429\u0451\u043B\u043A\u043D\u0438\u0442\u0435 \u043F\u043E \u0441\u0438\u0441\u0442\u0435\u043C\u0435, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438",
        "warzone.description.notPartOfWarzone": "\u042D\u0442\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442 \u0432\xA0\u0437\u043E\u043D\u0443 \u0431\u043E\u0435\u0432\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439",
        "warzone.adjacency.format": "\u042D\u0442\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\xA0\u2014 {{adjacencyStatus}}.",
        "warzone.adjacency.frontline": "\u041B\u0438\u043D\u0438\u044F \u0444\u0440\u043E\u043D\u0442\u0430",
        "warzone.adjacency.secondline": "\u0417\u043E\u043D\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0431\u043E\u0451\u0432",
        "warzone.adjacency.backline": "\u0410\u0440\u044C\u0435\u0440\u0433\u0430\u0440\u0434",
        "warzone.advantage.header": "\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E",
        "warzone.advantage.objectives": "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435 \u0446\u0435\u043B\u0438: {{amount}}%",
        "warzone.advantage.adjacency": "\u0421\u043E\u0441\u0435\u0434\u043D\u0438\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u044B: {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}} \u043E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u0431\u043E\u043D\u0443\u0441\u043E\u043C \u043A \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0443 \u0432 {{advantageAmount}}%",
        "warzone.advantage.noAdvantage": "\u041D\u0438 \u043E\u0434\u043D\u0430 \u0438\u0437 \u0441\u0442\u043E\u0440\u043E\u043D \u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E\u043C",
        "warzone.status.ownership": "<b>{{defendingFaction}}</b>: {{contestedStatus}}",
        "warzone.status.withPercentage": "{{contestedAmount}}% {{contestedStatus}}",
        "warzone.status.uncontested": "<b>\u043D\u0435 \u043E\u0441\u043F\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F</b>",
        "warzone.status.stable": "<b>\u0421\u0442\u0430\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430</b>",
        "warzone.status.contested": "<b>\u041E\u0441\u043F\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F</b>",
        "warzone.status.vulnerable": "<font color=\"red\"><b>\u0423\u044F\u0437\u0432\u0438\u043C\u043E\u0441\u0442\u044C</b></font>",
        "warzone.table.name": "\u0421\u0438\u0441\u0442\u0435\u043C\u0430",
        "warzone.table.constellation": "\u0421\u043E\u0437\u0432\u0435\u0437\u0434\u0438\u0435",
        "warzone.table.contested": "\u041E\u0441\u043F\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
        "warzone.table.advantage": "\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E",
        "warzone.table.adjacency": "\u0421\u0442\u0430\u0442\u0443\u0441",
        "warzone.tab.table": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438",
        "warzone.tab.map": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u0430\u0440\u0442\u043E\u0439",
        "warzone.leaderboard.points": "\u041E\u0447\u043A\u0438 \u0437\u0430 \u043F\u043E\u0431\u0435\u0434\u0443",
        "warzone.leaderboard.kills": "\u0423\u0431\u0438\u0439\u0441\u0442\u0432\u0430",
        "warzone.leaderboard.enlisted": "\u0421\u043E\u0441\u0442\u043E\u0438\u0442 \u0432 {{faction}}",
        "warzone.leaderboard.rank": "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0440\u0430\u043D\u0433",
        "warzone.notEnlisted": "\u041D\u0435 \u0441\u043E\u0441\u0442\u043E\u0438\u0442 \u0432 \u043E\u043F\u043E\u043B\u0447\u0435\u043D\u0438\u0438",
        "warzone.leaderboard.tooltip.points.yesterday": "\u041E\u0447\u043A\u043E\u0432 \u043F\u043E\u0431\u0435\u0434\u044B \u0432\u0447\u0435\u0440\u0430",
        "warzone.leaderboard.tooltip.points.lastWeek": "\u041E\u0447\u043A\u043E\u0432 \u043F\u043E\u0431\u0435\u0434\u044B \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u043D\u0435\u0434\u0435\u043B\u044E",
        "warzone.leaderboard.tooltip.points.total": "\u041E\u0447\u043A\u043E\u0432 \u043F\u043E\u0431\u0435\u0434\u044B \u0432\u0441\u0435\u0433\u043E",
        "warzone.leaderboard.tooltip.kills.yesterday": "\u0423\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043E \u0432\u0447\u0435\u0440\u0430",
        "warzone.leaderboard.tooltip.kills.lastWeek": "\u0423\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043E \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u044E\u044E \u043D\u0435\u0434\u0435\u043B\u044E",
        "warzone.leaderboard.tooltip.kills.total": "\u0412\u0441\u0435\u0433\u043E \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043E",
        "warzone.ranks.gallente.0": "\u0421\u0442\u0440\u0430\u0436 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438",
        "warzone.ranks.gallente.1": "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442-\u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A",
        "warzone.ranks.gallente.2": "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442-\u0441\u0442\u0440\u0430\u0436",
        "warzone.ranks.gallente.3": "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442-\u0445\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C",
        "warzone.ranks.gallente.4": "\u0425\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C \u0429\u0438\u0442\u0430",
        "warzone.ranks.gallente.5": "\u0425\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C \u0414\u043E\u0441\u043F\u0435\u0445\u0430",
        "warzone.ranks.gallente.6": "\u0412\u0438\u0446\u0435-\u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0440",
        "warzone.ranks.gallente.7": "\u0413\u0435\u043D\u0435\u0440\u0430\u043B-\u043C\u0430\u0439\u043E\u0440",
        "warzone.ranks.gallente.8": "\u0413\u0435\u043D\u0435\u0440\u0430\u043B-\u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442",
        "warzone.ranks.gallente.9": "\u0413\u0435\u043D\u0435\u0440\u0430\u043B-\u043B\u044E\u043C\u0438\u043D\u044D\u0440",
        "warzone.ranks.amarr.0": "\u041F\u0430\u043B\u0430\u0434\u0438\u043D-\u043A\u0440\u0435\u0441\u0442\u043E\u043D\u043E\u0441\u0435\u0446",
        "warzone.ranks.amarr.1": "\u0422\u0430\u043C\u043F\u043B\u0438\u0435\u0440-\u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442",
        "warzone.ranks.amarr.2": "\u041A\u0430\u0440\u0434\u0438\u043D\u0430\u043B-\u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442",
        "warzone.ranks.amarr.3": "\u0412\u044B\u0441\u0448\u0438\u0439 \u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442",
        "warzone.ranks.amarr.4": "\u0418\u043C\u043F\u0435\u0440\u0441\u043A\u0438\u0439 \u043C\u0430\u0439\u043E\u0440",
        "warzone.ranks.amarr.5": "\u041C\u0430\u0440\u0448\u0430\u043B-\u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0440",
        "warzone.ranks.amarr.6": "\u041A\u043E\u043C\u0430\u043D\u0434\u043E\u0440 \u0418\u043C\u043F\u0435\u0440\u0438\u0438",
        "warzone.ranks.amarr.7": "\u0422\u0440\u0438\u0431\u0443\u043D-\u043F\u043E\u043B\u043A\u043E\u0432\u043D\u0438\u043A",
        "warzone.ranks.amarr.8": "\u041B\u0435\u0433\u0430\u0442-\u043A\u043E\u043C\u043C\u043E\u0434\u043E\u0440",
        "warzone.ranks.amarr.9": "\u0411\u043E\u0436\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043A\u043E\u043C\u043C\u043E\u0434\u043E\u0440",
        "warzone.ranks.caldari.0": "\u042D\u043D\u0441\u0438\u043D \u041F\u0440\u043E\u0442\u0435\u043A\u0442\u043E\u0440\u0430\u0442\u0430",
        "warzone.ranks.caldari.1": "\u0412\u0442\u043E\u0440\u043E\u0439 \u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442",
        "warzone.ranks.caldari.2": "\u041F\u0435\u0440\u0432\u044B\u0439 \u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442",
        "warzone.ranks.caldari.3": "\u041A\u0430\u043F\u0438\u0442\u0430\u043D",
        "warzone.ranks.caldari.4": "\u041C\u0430\u0439\u043E\u0440",
        "warzone.ranks.caldari.5": "\u041F\u043E\u0434\u043F\u043E\u043B\u043A\u043E\u0432\u043D\u0438\u043A",
        "warzone.ranks.caldari.6": "\u041F\u043E\u043B\u043A\u043E\u0432\u043D\u0438\u043A",
        "warzone.ranks.caldari.7": "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u044D\u0441\u043A\u0430\u0434\u0440\u044B",
        "warzone.ranks.caldari.8": "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u0443\u0434\u0430\u0440\u043D\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u044B",
        "warzone.ranks.caldari.9": "\u0411\u0440\u0438\u0433\u0430\u0434\u043D\u044B\u0439 \u0433\u0435\u043D\u0435\u0440\u0430\u043B",
        "warzone.ranks.minmatar.0": "\u0417\u0430\u0449\u0438\u0442\u043D\u0438\u043A \u0420\u043E\u0434\u0438\u043D\u044B",
        "warzone.ranks.minmatar.1": "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442 \u0428\u0438\u043F\u0430",
        "warzone.ranks.minmatar.2": "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442 \u041A\u043E\u043F\u044C\u044F",
        "warzone.ranks.minmatar.3": "\u041A\u0430\u043F\u0438\u0442\u0430\u043D-\u043C\u0441\u0442\u0438\u0442\u0435\u043B\u044C",
        "warzone.ranks.minmatar.4": "\u041A\u043E\u043C\u0430\u043D\u0434\u043E\u0440 \u041F\u0438\u043A\u0438",
        "warzone.ranks.minmatar.5": "\u041A\u043E\u043C\u0430\u043D\u0434\u043E\u0440 \u041A\u043B\u0438\u043D\u043A\u0430",
        "warzone.ranks.minmatar.6": "\u041A\u043E\u043C\u0430\u043D\u0434\u043E\u0440 \u041A\u043E\u0433\u0442\u044F",
        "warzone.ranks.minmatar.7": "\u041C\u0430\u0439\u043E\u0440-\u0432\u043E\u0448\u0443\u0434",
        "warzone.ranks.minmatar.8": "\u041F\u043E\u043B\u043A\u043E\u0432\u043D\u0438\u043A-\u043C\u0430\u0442\u0430\u0440",
        "warzone.ranks.minmatar.9": "\u0413\u0435\u043D\u0435\u0440\u0430\u043B-\u0432\u0430\u043B\u044C\u043A\u043B\u0438\u0440"
      }
    },
    zh: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "\u7C73\u739B\u5854\u5C14\u5171\u548C\u56FD",
        "warzone.faction.amarr": "\u827E\u739B\u5E1D\u56FD",
        "warzone.faction.gallente": "\u76D6\u4F26\u7279\u8054\u90A6",
        "warzone.faction.caldari": "\u52A0\u8FBE\u91CC\u5408\u4F17\u56FD",
        "warzone.faction.angel": "\u5929\u4F7F\u4F01\u4E1A\u8054\u5408\u4F53",
        "warzone.faction.guristas": "\u53E4\u65AF\u5854\u65AF\u6D77\u76D7",
        "warzone.faction-short.minmatar": "\u7C73\u739B\u5854\u5C14",
        "warzone.faction-short.amarr": "\u827E\u739B",
        "warzone.faction-short.gallente": "\u76D6\u4F26\u7279",
        "warzone.faction-short.caldari": "\u52A0\u8FBE\u91CC",
        "warzone.faction-short.angel": "\u5929\u4F7F\u4F01\u4E1A\u8054\u5408\u4F53",
        "warzone.faction-short.guristas": "\u53E4\u65AF\u5854\u65AF\u6D77\u76D7",
        "warzone.corporation.gallente": "\u8054\u90A6\u9632\u52A1\u8054\u5408\u4F1A",
        "warzone.corporation.caldari": "\u5408\u4F17\u56FD\u62A4\u536B\u519B",
        "warzone.corporation.amarr": "\u5E1D\u56FD\u5341\u5B57\u519B\u7B2C\u4E8C\u5341\u56DB\u519B\u56E2",
        "warzone.corporation.minmatar": "\u90E8\u65CF\u89E3\u653E\u529B\u91CF",
        "warzone.corporation.angel": "\u5929\u4F7F\u4F01\u4E1A\u8054\u5408\u4F53",
        "warzone.corporation.guristas": "\u53E4\u65AF\u5854\u65AF\u6D77\u76D7",
        "warzone.status.uncontested": "<b>\u65E0\u4EBA\u4E89\u593A</b>",
        "warzone.status.stable": "<b>\u7A33\u5B9A</b>",
        "warzone.status.contested": "<b>\u4E89\u593A\u4E2D</b>",
        "warzone.status.vulnerable": "<font color=\"red\"><b>\u53EF\u88AB\u653B\u51FB</b></font>",
        "warzone.tooltip.progress": "<font color=\"white\"><b>{{count}}</b></font>\u661F\u7CFB\u88AB<font color=\"white\"><b>{{faction}}</b></font>\u5360\u9886",
        "warzone.adjacency.format": "\u8FD9\u4E2A\u661F\u7CFB\u662F{{adjacencyStatus}}\u3002",
        "warzone.adjacency.frontline": "\u524D\u7EBF",
        "warzone.adjacency.secondline": "\u6307\u6325\u8FD0\u4F5C",
        "warzone.adjacency.backline": "\u540E\u5907",
        "warzone.advantage.header": "\u4F18\u52BF",
        "warzone.advantage.objectives": "\u5B8C\u6210\u76EE\u6807\uFF1A {{amount}}%",
        "warzone.advantage.adjacency": "\u76F8\u90BB\u661F\u7CFB\uFF1A {{amount}}%",
        "warzone.advantage.resolved": "{{advantageFaction}}\u7684\u4F18\u52BF\u52A0\u6210\u4E3A{{advantageAmount}}%",
        "warzone.advantage.noAdvantage": "\u53CC\u65B9\u90FD\u672A\u53D6\u5F97\u4F18\u52BF",
        "warzone.description.nothingSelected": "\u70B9\u51FB\u661F\u7CFB\u6765\u4E86\u89E3\u8BE6\u60C5",
        "warzone.description.notPartOfWarzone": "\u8FD9\u4E2A\u661F\u7CFB\u4E0D\u5C5E\u4E8E\u6218\u533A",
        "warzone.table.name": "\u661F\u7CFB",
        "warzone.table.constellation": "\u661F\u5EA7",
        "warzone.table.contested": "\u4E89\u593A\u4E2D",
        "warzone.table.advantage": "\u4F18\u52BF",
        "warzone.table.adjacency": "\u72B6\u6001",
        "warzone.tab.table": "\u7EC6\u8282",
        "warzone.tab.map": "\u63A7\u5236\u5730\u56FE",
        "warzone.leaderboard.points": "\u80DC\u5229\u70B9\u6570",
        "warzone.leaderboard.kills": "\u51FB\u6740",
        "warzone.leaderboard.enlisted": "\u5E94\u5F81\u52A0\u5165\u4E86 {{faction}}",
        "warzone.leaderboard.rank": "\u5F53\u524D\u519B\u8854",
        "warzone.notEnlisted": "\u672A\u5E94\u5F81",
        "warzone.leaderboard.tooltip.points.yesterday": "\u6628\u65E5\u8D62\u53D6\u70B9",
        "warzone.leaderboard.tooltip.points.lastWeek": "\u4E0A\u5468\u8D62\u53D6\u70B9",
        "warzone.leaderboard.tooltip.points.total": "\u8D62\u53D6\u70B9\u603B\u6570",
        "warzone.leaderboard.tooltip.kills.yesterday": "\u6628\u65E5\u51FB\u6BC1\u6B21\u6570",
        "warzone.leaderboard.tooltip.kills.lastWeek": "\u4E0A\u5468\u7684\u51FB\u6BC1\u6B21\u6570",
        "warzone.leaderboard.tooltip.kills.total": "\u51FB\u6BC1\u603B\u6570",
        "warzone.ranks.gallente.0": "\u8054\u90A6\u6C11\u5175",
        "warzone.ranks.gallente.1": "\u9632\u5FA1\u8005\u5C09\u5B98",
        "warzone.ranks.gallente.2": "\u4FDD\u62A4\u8005\u5C09\u5B98",
        "warzone.ranks.gallente.3": "\u5C97\u54E8\u5C09\u5B98",
        "warzone.ranks.gallente.4": "\u5E87\u62A4\u6307\u6325\u5B98",
        "warzone.ranks.gallente.5": "\u5B88\u62A4\u6307\u6325\u5B98",
        "warzone.ranks.gallente.6": "\u6B21\u7EA7\u6307\u6325\u5B98",
        "warzone.ranks.gallente.7": "\u5C11\u5C06",
        "warzone.ranks.gallente.8": "\u4E2D\u5C06",
        "warzone.ranks.gallente.9": "\u4E0A\u5C06",
        "warzone.ranks.amarr.0": "\u5341\u5B57\u519B\u9A91\u58EB",
        "warzone.ranks.amarr.1": "\u5723\u6BBF\u9A91\u58EB\u5C09\u5B98",
        "warzone.ranks.amarr.2": "\u7EA2\u8863\u5C09\u5B98",
        "warzone.ranks.amarr.3": "\u9996\u5E2D\u5C09\u5B98",
        "warzone.ranks.amarr.4": "\u5E1D\u56FD\u6821\u5B98",
        "warzone.ranks.amarr.5": "\u9AD8\u9636\u6307\u6325\u5B98",
        "warzone.ranks.amarr.6": "\u51EF\u65CB\u6307\u6325\u5B98",
        "warzone.ranks.amarr.7": "\u62A4\u6C11\u4E0A\u6821",
        "warzone.ranks.amarr.8": "\u7687\u5BB6\u6307\u6325\u5B98",
        "warzone.ranks.amarr.9": "\u795E\u5723\u6307\u6325\u5B98",
        "warzone.ranks.caldari.0": "\u62A4\u536B\u519B\u638C\u65D7\u5B98",
        "warzone.ranks.caldari.1": "\u5C11\u5C09",
        "warzone.ranks.caldari.2": "\u4E2D\u5C09",
        "warzone.ranks.caldari.3": "\u4E0A\u5C09",
        "warzone.ranks.caldari.4": "\u5C11\u6821",
        "warzone.ranks.caldari.5": "\u4E2D\u6821",
        "warzone.ranks.caldari.6": "\u4E0A\u6821",
        "warzone.ranks.caldari.7": "\u8054\u961F\u957F",
        "warzone.ranks.caldari.8": "\u653B\u51FB\u6307\u6325\u5B98",
        "warzone.ranks.caldari.9": "\u51C6\u5C06",
        "warzone.ranks.minmatar.0": "\u6C11\u65CF\u6218\u58EB",
        "warzone.ranks.minmatar.1": "\u5C16\u5200\u5C09\u5B98",
        "warzone.ranks.minmatar.2": "\u957F\u77DB\u5C09\u5B98",
        "warzone.ranks.minmatar.3": "\u590D\u4EC7\u961F\u957F",
        "warzone.ranks.minmatar.4": "\u9A91\u5175\u6307\u6325\u5B98",
        "warzone.ranks.minmatar.5": "\u5200\u950B\u6307\u6325\u5B98",
        "warzone.ranks.minmatar.6": "\u9E70\u722A\u6307\u6325\u5B98",
        "warzone.ranks.minmatar.7": "\u66D9\u5149\u5C11\u6821",
        "warzone.ranks.minmatar.8": "\u739B\u5854\u5C14\u4E0A\u6821",
        "warzone.ranks.minmatar.9": "\u74E6\u57FA\u5C14\u5C06\u519B",
        "warzone.ranks.angel.0": "Ishim Associate",
        "warzone.ranks.angel.1": "Kerubim Guerilla",
        "warzone.ranks.angel.2": "Malakim Soldier",
        "warzone.ranks.angel.3": "Serafim Captain",
        "warzone.ranks.angel.4": "Elohim Sublord",
        "warzone.ranks.angel.5": "Ophanim Crimelord",
        "warzone.ranks.angel.6": "Yazatim Overlord",
        "warzone.ranks.angel.7": "Principal Warlord",
        "warzone.ranks.angel.8": "Throne Eminence",
        "warzone.ranks.angel.9": "Domination Kleptarch",
        "warzone.ranks.guristas.0": "Bandit Scout",
        "warzone.ranks.guristas.1": "Corsair Hunter",
        "warzone.ranks.guristas.2": "Commando Freebooter",
        "warzone.ranks.guristas.3": "Ace Pirate",
        "warzone.ranks.guristas.4": "Hijack Commander",
        "warzone.ranks.guristas.5": "Heist Crew Chief",
        "warzone.ranks.guristas.6": "Raid Wing Captain",
        "warzone.ranks.guristas.7": "Dread Commodore",
        "warzone.ranks.guristas.8": "Insurgent Admiral",
        "warzone.ranks.guristas.9": "Guri Fleet Admiral"
      }
    },
    it: {
      translation: {
        "fmt.number": "{{value, number}}",
        "warzone.faction.minmatar": "Repubblica Minmatar",
        "warzone.faction.amarr": "Impero Amarr",
        "warzone.faction.gallente": "Federazione Gallente",
        "warzone.faction.caldari": "Stato Caldari",
        "warzone.faction-short.minmatar": "Minmatar",
        "warzone.faction-short.amarr": "Amarr",
        "warzone.faction-short.gallente": "Gallente",
        "warzone.faction-short.caldari": "Caldari"
      }
    }
  }
});
i18n.use(initReactI18next).init();
var i18n$1 = i18n;
export { i18n$1 as default };